
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Sparkles, Award, Gamepad } from 'lucide-react';
import Header from '@/components/layout/Header';
import ProgressTrackingPage from '@/components/gamification/ProgressTrackingPage';
import CareerSimGame from '@/components/gamification/career-sim/CareerSimGame';
import Layout from '@/components/layout/Layout';

const Gamification: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'progress' | 'career-sim'>('progress');

  return (
    <Layout>
      <main className="pt-16 pb-20 px-4 max-w-7xl mx-auto">
        <div className="mb-4 animate-fade-in">
          <div className="flex items-center gap-2 mb-2">
            <div className="bg-purple-500/10 p-1.5 rounded-full">
              <Sparkles className="h-5 w-5 text-purple-500" />
            </div>
            <h1 className="text-2xl font-bold">Artist Progress</h1>
          </div>
        </div>
        
        <Tabs value={activeTab} onValueChange={(val) => setActiveTab(val as 'progress' | 'career-sim')} className="w-full">
          <TabsList className="grid w-full max-w-md grid-cols-2 mb-4">
            <TabsTrigger value="progress" className="flex items-center gap-2">
              <Award className="h-4 w-4" />
              <span>Artist Progress</span>
            </TabsTrigger>
            <TabsTrigger value="career-sim" className="flex items-center gap-2">
              <Gamepad className="h-4 w-4" />
              <span>Career Simulator</span>
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="progress" className="mt-0">
            <ProgressTrackingPage />
          </TabsContent>
          
          <TabsContent value="career-sim" className="mt-0">
            <CareerSimGame />
          </TabsContent>
        </Tabs>
      </main>
    </Layout>
  );
};

export default Gamification;
